import { render } from "./FileWord.vue.js?vue&type=template&id=1eaaf8a1!=!../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./FileWord.vue?vue&type=template&id=1eaaf8a1"
const script = {}

import exportComponent from "../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__